<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ "campaign.messagePayload.title" | translate }}
        </h4>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="onClose()"
        ></button>
      </div>
      <div class="modal-body">
        <h5 class="modal-title">
          {{ "campaign.messagePayload.messageStatus" | translate }}
          @if (campaignMessage.failed) {
            <span class="badge font-14 bg-danger text-capitalize">{{
              "campaign.messagePayload.badgeFailed" | translate
            }}</span>
          } @else if (campaignMessage.sent) {
            <span class="badge font-14 bg-success text-capitalize">{{
              "campaign.messagePayload.badgeSent" | translate
            }}</span>
          }
        </h5>
        @if (messageId) {
          <h6 class="modal-title">
            Message ID: {{ messageId
            }}<a
              href="javascript:void(0);"
              (click)="copyMessageId()"
              class="ms-1 action-icon"
              [matTooltip]="'campaign.messagePayload.copyTooltip' | translate"
            >
              <i class="mdi mdi-content-copy"></i
            ></a>
          </h6>
        }

        <hr />

        <div class="list-group list-group-flush my-2">
          @if (
            campaignMessage.sent ||
            campaignMessage.delivered ||
            campaignMessage.read ||
            campaignMessage.failed ||
            campaignMessage.clicked
          ) {
            @if (campaignMessage.sent) {
              <span>
                <i class="ri-check-line"></i>
                {{ "campaign.messagePayload.statusSent" | translate }}
                @if (campaignMessage.sentAt) {
                  {{
                    "campaign.messagePayload.atTime"
                      | translate
                        : {
                            time:
                              campaignMessage.sentAt
                              | timezoneDate
                                : "DD/MM/YYYY HH:mm"
                                : getTimezoneCompanyCurrentUser(),
                          }
                  }}
                }
              </span>
            }

            @if (campaignMessage.delivered) {
              <span>
                <i class="ri-check-double-line"></i>
                {{ "campaign.messagePayload.statusDelivered" | translate }}
                @if (campaignMessage.deliveredAt) {
                  {{
                    "campaign.messagePayload.atTime"
                      | translate
                        : {
                            time:
                              campaignMessage.deliveredAt
                              | timezoneDate
                                : "DD/MM/YYYY HH:mm"
                                : getTimezoneCompanyCurrentUser(),
                          }
                  }}
                }
              </span>
            }

            @if (campaignMessage.read) {
              <span>
                <i class="ri-check-double-line text-primary"></i>
                {{ "campaign.messagePayload.statusRead" | translate }}
                @if (campaignMessage.readAt) {
                  {{
                    "campaign.messagePayload.atTime"
                      | translate
                        : {
                            time:
                              campaignMessage.readAt
                              | timezoneDate
                                : "DD/MM/YYYY HH:mm"
                                : getTimezoneCompanyCurrentUser(),
                          }
                  }}
                }
              </span>
            }

            @for (click of campaignMessage.clicks; track $index) {
              <span>
                <i class="ri-cursor-line text-success"></i>
                {{ "campaign.messagePayload.clicked" | translate }}
                @if (click.text) {
                  <strong>{{ click.text }}</strong>
                }
                @if (click.at) {
                  {{
                    "campaign.messagePayload.atTime"
                      | translate
                        : {
                            time:
                              click.at
                              | timezoneDate
                                : "DD/MM/YYYY HH:mm"
                                : getTimezoneCompanyCurrentUser(),
                          }
                  }}
                }
                @if (click.postbackData) {
                  <small class="text-muted d-block">
                    {{ "campaign.messagePayload.clickTarget" | translate }}:
                    {{ click.postbackData }}
                  </small>
                }
              </span>
            }

            @if (campaignMessage.failed) {
              <span>
                <i class="ri-error-warning-line text-danger"></i>
                {{ "campaign.messagePayload.statusFailed" | translate }}
                @if (campaignMessage.failedAt) {
                  {{
                    "campaign.messagePayload.atTime"
                      | translate
                        : {
                            time:
                              campaignMessage.failedAt
                              | timezoneDate
                                : "DD/MM/YYYY HH:mm"
                                : getTimezoneCompanyCurrentUser(),
                          }
                  }}
                }
                <small>
                  <a
                    href="javascript:void(0);"
                    (click)="getMessageErrorReason()"
                    class="ms-1 action-icon"
                    [matTooltip]="
                      'campaign.messagePayload.moreInfoTooltip' | translate
                    "
                    >{{
                      "campaign.messagePayload.fetchMoreInfo" | translate
                    }}</a
                  >
                  @if (messageId) {
                    <a
                      href="javascript:void(0);"
                      (click)="getMessageFailedReason()"
                      class="ms-2 action-icon"
                      [matTooltip]="
                        'campaign.messagePayload.moreInfoTooltip' | translate
                      "
                      >{{
                        "campaign.messagePayload.fetchProviderHistory"
                          | translate
                      }}</a
                    >
                  }
                </small>
              </span>

              @if (!!errorMessage) {
                <div class="card card-body">
                  <pre> {{ errorMessage }} </pre>
                  <p>
                    <button
                      type="button"
                      class="btn btn-dark btn-small"
                      (click)="goToGoogleTranslate(errorMessage)"
                    >
                      {{
                        "campaign.messagePayload.translateMessage" | translate
                      }}
                    </button>
                  </p>
                </div>
              }

              @if (!!failedMessage) {
                <div class="card card-body">
                  <pre> {{ failedMessage }} </pre>
                  <p>
                    <button
                      type="button"
                      class="btn btn-dark btn-small"
                      (click)="goToGoogleTranslate(failedMessage)"
                    >
                      {{
                        "campaign.messagePayload.translateMessage" | translate
                      }}
                    </button>
                  </p>
                </div>
              }
            }
          } @else {
            <span>
              {{ "campaign.messagePayload.noStatusInfo" | translate }}
            </span>
          }
        </div>
      </div>
    </div>
  </div>
</div>
